import { Link, NakedButton } from 'roo-ui/components';
import { CONTACT_US_URL, CUSTOMER_SUPPORT_HOTLINE_AU, CUSTOMER_SUPPORT_HOTLINE_INTL } from 'config/constants';
import { expiredCreditCardModalLinkSelected } from 'lib/gaTracking/crossPageEvents';
import { openLiveChat } from 'lib/liveChat/actions';
import TelLink from 'components/TelLink';

const variant = 'error';
const header = 'Please update your payment details';
const body = 'We were unable to process your refund as your credit card has expired. Please update your credit card and try again.';
const button = 'Update payment details';

const onClickLiveChat = () => {
  openLiveChat();
  expiredCreditCardModalLinkSelected('live chat');
};

export const updatePaymentMethodModalProps = {
  variant,
  header,
  body,
  button,
};

export const contactUsModalProps = {
  variant,
  header: 'Your credit card has expired',
  body: (
    <>
      We were unable to process payment, and your changes have not been completed.
      <br />
      <br />
      To continue with your booking, please contact us via{' '}
      <Link as={NakedButton} onClick={onClickLiveChat} underline>
        live chat
      </Link>
      ,{' '}
      <Link target="_blank" href={`${CONTACT_US_URL}`} onClick={() => expiredCreditCardModalLinkSelected('email')} underline>
        email
      </Link>
      , or call{' '}
      <TelLink
        number={CUSTOMER_SUPPORT_HOTLINE_AU}
        color="greys.steel"
        underline
        onClick={() => expiredCreditCardModalLinkSelected('call customer support')}
      />{' '}
      (outside Australia:{' '}
      <TelLink
        number={CUSTOMER_SUPPORT_HOTLINE_INTL}
        color="greys.steel"
        underline
        onClick={() => expiredCreditCardModalLinkSelected('call international customer support')}
      />
      ).
    </>
  ),
  button: 'Close',
};
